import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Button from "src/components/Button";
import Tabs from "src/components/layout/Tabs";
import useWindowSize from "src/hooks/useWindowSize";
import Link from "src/components/Link";
import Tab from "src/components/layout/Tab";

type TabProps = {
	to: string;
	label: string;
};

type TabNavProps = {
	tabs: TabProps[];
	type?: string;
	variant: "light" | "dark";
};

const TabNav = ({ tabs, type, variant }: TabNavProps) => {
	const gtmTag = (item: any) =>
		` gtm-tab-${type}-nav--${item.label
			.replace(/\s+/g, "-")
			.toLowerCase()}`;
	const size = useWindowSize();
	const location = useLocation();
	const [visible, setVisible] = useState(false);
	// const variant = auth.type === "student" ? "light" : "dark";

	useEffect(() => {
		setVisible(false);
	}, [location]);

	if (size.isPhone) {
		const activeTab = tabs.find((t) => t?.to === location.pathname) as any;

		return (
			<div className="flex flex-col flex-1 w-full relative shadow">
				<div
					className={`flex flex-col transition-all ${
						visible ? "rounded-t-md" : "rounded-md"
					} ${
						variant === "dark"
							? "bg-dark text-white"
							: "bg-white text-dark"
					}`}
				>
					<div
						onClick={() => setVisible(!visible)}
						className="px-4 py-2 flex items-center justify-between relative z-20 cursor-pointer"
					>
						<strong>{activeTab?.label}</strong>
						<i
							className={`fas fa-angle-${
								visible ? "up" : "down"
							}`}
						></i>
					</div>
					<AnimatePresence>
						{visible && (
							<motion.div
								className={`flex flex-col z-10 absolute top-[43px] rounded-b-md left-0 right-0 shadow ${
									variant === "dark"
										? "bg-dark text-white"
										: "bg-white text-dark"
								}`}
								initial={{ opacity: 0, y: -20 }}
								exit={{ opacity: 0, y: -20 }}
								animate={{ opacity: 1, y: 0 }}
							>
								{tabs.map((t, index) => {
									if (t?.to === activeTab?.to) {
										return <></>;
									}
									return (
										<Link
											key={`${t?.to}-${index}`}
											to={t?.to}
											className={`border-b-[1px] px-4 py-2 border-gray ${gtmTag(
												t
											)}`}
										>
											{t?.label}
										</Link>
									);
								})}
							</motion.div>
						)}
					</AnimatePresence>
				</div>
			</div>
		);
	}

	return (
		<div className="flex flex-col w-full relative">
			<div className="flex items-center gap-4">
				<div className="md:flex hidden lg:hidden">
					<Button type="dark" iconOnly to="/tasks">
						<i className="fas fa-arrow-left"></i>
					</Button>
				</div>
				<Tabs.Container>
					{tabs.map((t, index) => (
						<Tab
							to={t.to}
							key={`${t.to}-${index}`}
							className={gtmTag(t)}
						>
							{t.label}
						</Tab>
					))}
				</Tabs.Container>
			</div>
		</div>
	);
};

TabNav.defaultProps = {
	variant: "light",
};

export default TabNav;
